// viewmodels/useLoginViewModel.ts

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../../services/APIService";

export const useLoginViewModel = (deps: {
  setloggedState: React.Dispatch<React.SetStateAction<number>>;
  setloggedID: React.Dispatch<React.SetStateAction<string>>;
  setTag: React.Dispatch<React.SetStateAction<string>>;
  setName: React.Dispatch<React.SetStateAction<string>>;
  setToken: React.Dispatch<React.SetStateAction<string>>;
  setAccountStatus: React.Dispatch<React.SetStateAction<string>>;
  setTestAlarms: React.Dispatch<React.SetStateAction<number>>;
  setAGBStatus: React.Dispatch<React.SetStateAction<number>>;
  setDSGVOStatus: React.Dispatch<React.SetStateAction<number>>;
  setUseCondStatus: React.Dispatch<React.SetStateAction<number>>;
  setAlarmMonitorURL: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const isValidDate = (dateString: string) => !isNaN(Date.parse(dateString));

  const login = async () => {
    setEmailError("");
    setPasswordError("");

    if (!email) return setEmailError("Bitte Benutzernamen eingeben");
    if (!password) return setPasswordError("Bitte Passwort eingeben");
    if (password.length < 7)
      return setPasswordError("Das Passwort muss mindestens 8 Zeichen lang sein");

    try {
      deps.setloggedState(0);

      const data = await loginRequest(email, password);

      deps.setAGBStatus(parseInt(data.agbStatus));
      deps.setDSGVOStatus(parseInt(data.dsgvoStatus));
      deps.setUseCondStatus(parseInt(data.useCondStatus));
      deps.setAlarmMonitorURL(data.alarmMonitorURL);

      const payStatus = data.accountStatus;
      const testAlarmsInt = parseInt(data.testAlarms);

      const applyBaseUserData = () => {
        deps.setTag(data.tag);
        deps.setName(data.name);
        deps.setToken(data.token);
        deps.setloggedID(data.loggedID);
      };

      if (payStatus !== "Payed") {
        if (isValidDate(payStatus)) {
          const date = new Date(payStatus);
          applyBaseUserData();

          if (date >= new Date()) {
            deps.setloggedState(1);
            deps.setAccountStatus(payStatus);
            deps.setTestAlarms(data.testAlarms);
            navigate("/MainPage");
          } else {
            navigate("/PayPage");
          }
        } else if (payStatus === "Test") {
          applyBaseUserData();

          if (testAlarmsInt > 0) {
            deps.setloggedState(1);
            deps.setAccountStatus(payStatus);
            deps.setTestAlarms(data.testAlarms);
            navigate("/MainPage");
          } else {
            navigate("/PayPage");
          }
        } else {
          applyBaseUserData();
          navigate("/PayPage");
        }
      } else {
        applyBaseUserData();
        deps.setloggedState(1);
        deps.setAccountStatus(payStatus);
        deps.setTestAlarms(data.testAlarms);
        navigate("/MainPage");
      }
    } catch {
      setPasswordError("Falscher Benutzername oder Passwort");
    }
  };

  return {
    email,
    password,
    emailError,
    passwordError,
    passwordVisible,
    setEmail,
    setPassword,
    togglePasswordVisibility: () => setPasswordVisible(v => !v),
    login,
    navigateToSignIn: () => navigate("/SignIn"),
    navigateToForgetPassword: () => navigate("/ForgetPassword"),
  };
};